'use client';

import { c as _c } from "react/compiler-runtime";
import { MouseEvent } from 'react';
import { BodyShort, Heading, Link, VStack } from '@navikt/ds-react';
import { List, ListItem } from '@navikt/ds-react/List';
import { PageBlock } from '@navikt/ds-react/Page';
import type { AreaId } from '@/urls';
import { viewHistoryDepth } from '@/utils/useViewHistory';
const kontaktOss: Record<AreaId, string> = {
  arbeidsgiver: 'https://www.nav.no/arbeidsgiver/kontaktoss',
  arbeidstaker: 'https://www.nav.no/kontaktoss',
  samarbeidspartner: 'https://www.nav.no/kontaktoss'
};
function lastPaaNytt(e: MouseEvent) {
  e.preventDefault();
  location.reload();
}
function tilbake(e: MouseEvent) {
  e.preventDefault();
  history.go(-(viewHistoryDepth() + 1));
}
export default function ErrorPage(t0) {
  const $ = _c(20);
  const {
    area,
    onForrigeSkjermbilde
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <BodyShort textColor="subtle" size="small">Statuskode 500</BodyShort>;
    t2 = <Heading level="1" size="large" spacing={true}>Beklager, noe gikk galt</Heading>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <BodyShort>En teknisk feil på våre servere gjør at siden er utilgjengelig. Dette skyldes ikke noe du gjorde.</BodyShort>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <BodyShort>Du kan prøve å</BodyShort>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ListItem>vente noen minutter og{" "}<Link href="#" onClick={lastPaaNytt}>laste siden på nytt</Link></ListItem>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== onForrigeSkjermbilde) {
    t6 = onForrigeSkjermbilde && <ListItem><Link href="#" onClick={e => {
        e.preventDefault();
        onForrigeSkjermbilde();
      }}>gå tilbake til forrige skjermbilde</Link></ListItem>;
    $[5] = onForrigeSkjermbilde;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ListItem><Link href="#" onClick={tilbake}>gå tilbake til forrige side</Link></ListItem>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6) {
    t8 = <VStack gap="space-12">{t4}<List>{t5}{t6}{t7}</List></VStack>;
    $[8] = t6;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = kontaktOss[area];
  let t10;
  if ($[10] !== t9) {
    t10 = <BodyShort>Dersom problemet vedvarer, kan du{" "}<Link href={t9} target="_blank">kontakte oss (åpnes i ny fane)</Link>.</BodyShort>;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t8) {
    t11 = <div lang="nb">{t1}{t2}<VStack gap="space-24">{t3}{t8}{t10}</VStack></div>;
    $[12] = t10;
    $[13] = t8;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Heading level="2" size="large" spacing={true}>Something went wrong</Heading>;
    t13 = <BodyShort spacing={true}>This was caused by a technical fault on our servers. Please refresh this page or try again in a few minutes.</BodyShort>;
    $[15] = t12;
    $[16] = t13;
  } else {
    t12 = $[15];
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div lang="en">{t12}{t13}<BodyShort><Link href="https://www.nav.no/kontaktoss/en" target="_blank">Contact us (opens in new tab)</Link>{" "}if the problem persists.</BodyShort></div>;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t11) {
    t15 = <PageBlock width="text" gutters={true}><VStack gap="space-64" paddingBlock="space-64 space-80" data-aksel-template="500-v4">{t11}{t14}</VStack></PageBlock>;
    $[18] = t11;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  return t15;
}